import React from 'react';
import { message, Space, Table, Pagination, Tag, Row, Col, Form, Input, Divider, Tooltip, Button, Popconfirm } from 'antd';
import { PlusSquareOutlined, ProfileOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { httpClient } from "util/Api";
import { compareUIElementValue } from 'util/Compare';
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { setTableColumns } from "components/UIBuilder/Global/TableHelper";
import { getSectionGroupDataList } from "components/UIBuilder/Global/DataHelper";
import SubJobGroup from './SubJobGroup';
import * as SubJob from 'components/UIBuilder/SectionFunction/SubJob';
import CustomEmpty from "components/CustomEmpty";

export default class SubJobTable extends React.Component {
  constructor(props) {
    super();
    this.state = {
      columns: [],
      data: [],
      sort: false,
      pagination: {
        current: 1,
        ...config.component.Pagination
      },
      loaded: false, // 加载是否完成
      selectedRowKeys: [],
      manageGroupShow: false,
      addFromTemplateShow: false,
      submitConfirmShow: false,
      subJobGroupId: null,
      subJobId: null,
    }

    this.manageGroup = React.createRef();
    this.submitConfirm = React.createRef();
    this.addFromTemplate = React.createRef();
  }

  // //只有数据源变化时才刷新table
  // shouldComponentUpdate(nextProps, nextState) {
  //   return nextState.data !== this.state.data;
  // }

  //获取table的表头和数据
  componentDidMount() {
    if (this.props.section.autoLoad) {
      this.getSectionDataByDefault();
    }
    this.setSolumns();
  }

  setSolumns() {
    this.setState({ columns: setTableColumns({ props: this.props, sort: this.state.sort, sectionComponent: this.props.parentComponent, pageComponent: this.props.pageComponent }) })
  }

  //默认获取数据的方法
  getSectionDataByDefault() {
    getSectionGroupDataList({ component: this, current: this.state.pagination.current, pageSize: this.state.pagination.pageSize });
  }

  render() {
    return (
      <>
        {
          this.state.loaded ?
            this.state.data.length > 0 ? //判断有没有数据
              <Space direction="vertical" size="large" style={{ display: 'flex' }}>
                {
                  this.state.data.map((subJobGroupData, i) => <SubJobGroup key={i} data={subJobGroupData} component={this} columns={this.state.columns} viewConfig={this.props.viewConfig} />)
                }
              </Space>
              :
              <CustomEmpty /> : <img className='loading-icon' src="assets/images/icon/loading.svg" />
        }
      </>
    )
  }
}
